import { lazyDeinitializeAddinsForItem } from 'owa-addins-core';
import { updateFrameworkComponentHostItemIndexMap } from 'owa-addins-store';

// Cache the ids of Extensibility app iframes, indexed by Office Developer Platform conversationId
const addinFrames: Map<string /*conversationId*/, AddinFrameInfo> = new Map();
let isEventListenerAdded = false;

export default function prepareAddinCommunicationInPopout(
    childWindow: Window,
    hostItemIndex: string
) {
    // Listen for messages to and from Extensibility apps using postMessage
    if (!isEventListenerAdded) {
        window.addEventListener('message', event => windowMessageListener(event));
        isEventListenerAdded = true;
    }

    childWindow.addEventListener('message', event =>
        childWindowMessageListener(childWindow, event)
    );

    childWindow.addEventListener('beforeunload', () => onCloseWindow(childWindow, hostItemIndex));
    // mainwindow item popped out so update this map
    updateFrameworkComponentHostItemIndexMap('exfc_main');
}

function windowMessageListener(event: MessageEvent) {
    const conversationId = getConversationId(event);
    if (!conversationId) {
        return;
    }

    const addinFrameInfo = addinFrames.get(conversationId);
    const childWindow = addinFrameInfo?.childWindow;
    const addinFrameId = addinFrameInfo?.addinFrameId;

    if (childWindow && addinFrameId && event.source === childWindow.opener) {
        // Send this message to childWindow addinFrame
        const addinFrame = <HTMLIFrameElement>childWindow.document.getElementById(addinFrameId);
        if (addinFrame) {
            addinFrame.contentWindow.postMessage(event.data, addinFrame.src);
        }
    }
}

function childWindowMessageListener(childWindow: Window, event: MessageEvent) {
    const conversationId = getConversationId(event);
    if (!conversationId) {
        return;
    }

    // Send this message to the main OWA window
    if (!addinFrames.get(conversationId)) {
        // Determine which iframe corresponds to the sender
        const documentFrames = childWindow.document.getElementsByTagName('iframe');
        for (let i = 0; i < documentFrames.length; i++) {
            if (documentFrames[i].contentWindow === event.source) {
                // Save the iframe id for this conversation id
                addinFrames.set(conversationId, {
                    childWindow: childWindow,
                    addinFrameId: documentFrames[i].id,
                });
                break;
            }
        }
    }
    childWindow.opener.postMessage(event.data, childWindow.opener.location.href);
}

function onCloseWindow(childWindow: Window, hostItemIndex: string) {
    lazyDeinitializeAddinsForItem
        .import()
        .then(deinitializeAddinsForItem => deinitializeAddinsForItem(hostItemIndex, childWindow));
}

function getConversationId(event: MessageEvent) {
    try {
        return JSON.parse(event.data)._conversationId;
    } catch (err) {
        return undefined;
    }
}

interface AddinFrameInfo {
    childWindow: Window;
    addinFrameId: string;
}
